import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import MoreOption from "./MoreOptions";
import SaveDialog from "./SaveDialog";
import SettingsIcon from "./SettingsIcon";

export default function CustomCardHeader(props) {
  const {
    variant,
    timeRange,
    moodboard,
    handleMoodboard,
    settings,
    handleSetting,
  } = props;

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        {variant === "localboard" ||
        variant === "publicboard" ||
        variant === "analyser" ? (
          <div>
            <Typography variant="h6">{moodboard.title}</Typography>
            <Typography variant="body2" color="textSecondary">
              {timeRange}
            </Typography>
          </div>
        ) : null}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {variant === "localboard" ||
        variant === "publicboard" ||
        variant === "timeline"
          ? settings
              .filter(({ parent }) => parent.includes("header"))
              .map((setting) => (
                <div key={"setting" + setting.id}>
                  <SettingsIcon
                    setting={setting}
                    handleSettingClick={handleSetting}
                  />
                </div>
              ))
          : null}
        {variant === "localboard" || variant === "publicboard" ? (
          <MoreOption board={moodboard} variant={variant} />
        ) : null}
        {variant === "analyser" ? (
          <Box textAlign={"end"}>
            <SaveDialog
              moodboard={moodboard}
              handleMoodboard={handleMoodboard}
            />
          </Box>
        ) : null}
      </div>
    </div>
  );
}
